export const SYSTEM_DESIGN_WATER = {
  FEED_WATER: "vol_Raw_actual_total_day",
  PRODUCT_WATER: "vol_UF_net_filtrate_actual_total_day",
  GROSS_WATER: "vol_Gross_filtrate_actual_total_day",
};
